import React, {useEffect, useState} from "react";
import map from "lodash/map";
import classnames from "classnames";
import styles from "./ComparisonChart.scss";
import PropTypes from "prop-types";
import Reach from "yup/lib/util/reach";

function ComparisonChart(props) {
    const [hasImages, setHasImages] = useState([]);

    useEffect(() => {
        setHasImages(map(props.columns, column => !!column.src));
    }, []);

    const renderCheckColumns = (columns, isBorders = false) => {
        return map(columns, (column, index) => {
            let content;
            if (isBorders) {
                content = <div className={styles.checkItem}><div className={styles.rowItemInner} /></div>;
            } else {
                content = (
                    <div className={styles.checkItem}>
                        <i className={classnames("fas", {
                            "fa-check": column,
                            "fa-times": !column,
                        })}/>
                    </div>
                );
            }
            return (
                <div className={classnames(styles.checkColumn, styles.rowItem, {
                    [styles.checked]: column,
                    [styles.unchecked]: !column,
                    [styles.imageColumn]: hasImages[index],
                })}
                >{content}</div>
            );
        });
    }

    const renderRows = () => {
        return map(props.data, row => (
            <React.Fragment>
                <div className={styles.row}>
                    <div className={classnames(styles.rowItem, styles.featureColumn)}>
                        <div className={styles.featureText}>{row.text}</div>
                    </div>
                    <div className={styles.checkedColumns}>
                        {renderCheckColumns(row.columns)}
                    </div>
                </div>
                <div className={classnames(styles.row, styles.borderRow)}>
                    <div className={classnames(styles.rowItem, styles.featureColumn)}>
                        <div className={styles.rowItemInner} />
                    </div>
                    <div className={styles.checkedColumns}>
                        {renderCheckColumns(row.columns, true)}
                    </div>
                </div>
            </React.Fragment>
        ));
    }

    const renderColumnHeaders = () => {
        return [
            ,
            ...map(props.columns, column => {
                let content = <span>{column.text}</span>;
                if(column.src) {
                    content = <img src={column.src} alt={column.text} />;
                }
                return <div className={
                    classnames(styles.headerLabel, styles.checkColumn, {
                        [styles.imageHeader]: !!column.src
                    })}
                >{content}</div>
            }),
        ];
    }

    return (
        <div className={styles.root}>
            <div className={styles.header}>
                <div className={styles.headerInner}>
                    <div className={classnames(styles.featureColumn, styles.headerLabel)}>{props.firstColumnLabel}</div>
                    <div className={styles.checkedColumns}>
                        {renderColumnHeaders()}
                    </div>
                </div>
            </div>
            <div className={styles.rows}>
                {renderRows()}
            </div>
        </div>
    );
}

ComparisonChart.propTypes = {
    firstColumnLabel: PropTypes.string.isRequired,
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            src: PropTypes.string,
        }),
    ),
    data: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            columns: PropTypes.arrayOf(PropTypes.bool)
        })
    ),
};

export default ComparisonChart;
